<template>
  <v-card>
    <v-container fluid>
      <v-row dense class="text-h5">
        <v-col>
          {{ applicationRoute.name }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="authorization" class="mr-2" v-bind="attrs" v-on="on">
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar via de aplicação</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="applicationRoute.name"
                          label="Nome"
                          :hide-details="!errors.applicationRoute"
                          :error-messages="errors.applicationRoute"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_medicine"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" @click="deletePresentation">
              eva-trash-outline
            </v-icon>
          </authorization>
        </v-col>
      </v-row>

      <v-divider />

      <v-row dense>
        <v-col>
          <ApplicationSiteTable
            :applicationRoute="applicationRoute"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>

      <v-divider />

      <v-row>
        <v-col>
          <PresentationTable :applicationRoute="applicationRoute" :refreshList="refreshList" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import PresentationTable from "@/components/config/medicine/application_route/item/presentation_table.vue";
  import ApplicationSiteTable from "@/components/config/medicine/application_route/item/application_site_table.vue";

  export default {
    name: "ApplicationRouteListItem",
    props: {
      applicationRoute: Object,
      refreshList: Function,
    },
    components: {
      PresentationTable,
      ApplicationSiteTable,
    },
    data() {
      return {
        errors: {},
        dialog: null,
      };
    },
    methods: {
      deletePresentation() {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medicine/delete_application_route.gql"),
            variables: {
              applicationRouteId: this.applicationRoute.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/medicine/save_application_route.gql"),
          variables: {
            applicationRouteId: this.applicationRoute.id,
            name: this.applicationRoute.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.applicationRoute.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.applicationRoute = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
